// extracted by mini-css-extract-plugin
export default {"BannerImg":"OurStoryBody1_BannerImg__f0XhV","para":"OurStoryBody1_para__hp6bv","rectangle":"OurStoryBody1_rectangle__i95Ad","Size":"OurStoryBody1_Size__lDZy5"};